import { render, staticRenderFns } from "./LogCardPaid.vue?vue&type=template&id=53881ce6"
import script from "./LogCardPaid.vue?vue&type=script&lang=js"
export * from "./LogCardPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports